import Vue from 'vue'
import vueSocialSharing from 'vue-social-sharing'

Vue.use(vueSocialSharing)

const els = document.querySelectorAll("[id^='social-app--']")
if (els != null) {
  els.forEach((el) => {
    var vm = new Vue({
      name: 'vue-instance'
    })
    vm.$mount(el)
  })
}
